






































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { DateTime } from 'luxon';
import { Notification, NotificationsApi } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UIModule from '@/store/modules/ui';
import NotificationModule from '@/store/modules/notification';

@Component({
  components: {
  },
})
export default class NotificationCard extends Vue {
  public hover: boolean = false;

  @Prop({}) notification!: Notification;

  async navigate() {
    const { url } = this.notification;
    if (url) {
      this.$router.push(url as string);
      UIModule.SET_PANE(false);
      await this.markAsRead();
    }
  }

  get lastUpdated() {
    return DateTime.fromISO(this.notification.createdAt as string)
      .toLocaleString(DateTime.DATETIME_MED);
  }

  public async markAsRead() {
    NotificationModule.UPDATE_READ_ID(this.notification.id as string);
    const notificationsApi = new NotificationsApi(AppModule.apiConfig);
    const readNotifications = await notificationsApi.updateNotifications([this.notification]);
  }

  public async markAsUnRead() {
    NotificationModule.UPDATE_UNREAD_ID(this.notification.id as string);
    const notificationsApi = new NotificationsApi(AppModule.apiConfig);
    const readNotifications = await notificationsApi.updateNotifications([this.notification]);
  }
}
